import React, { useContext, useEffect, useState } from 'react';
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral';
import Footer from '../../components/footer/Footer';
import { ApiContext } from '../../context/ApiContext';
import { StyleContext } from '../../context/StyleContext';
import { TbTrash, TbPlus } from "react-icons/tb";
import { HiOutlineDocumentReport, HiOutlineChartSquareBar } from "react-icons/hi";
import { FcRating } from "react-icons/fc";
import { IoIosWarning, IoIosCheckmarkCircle, IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ModalMatrizTime from '../../components/modal/ModalMatrizTime';
import ModalExcluirMatriz from '../../components/modal/ModalExcluirMatriz';
import ModalRelatorioMatriz from '../../components/modal/ModalRelatorioMatriz';
import ModalGraficoMatriz from '../../components/modal/ModalGraficoMatriz';
import LoadingScreen from '../../components/LoadingScreen';

import { SimpleTreeView, TreeItem } from '@mui/x-tree-view';

export default function MatrizTime() {
    const { ListaCapacidadesMatriz, ArvoreCapacidadesMatriz, setCapacidadeAtualKey, setModalExcluirMatrizTime, modalExcluirMatrizTime, Success, Error, loading, CapacidadeAtualKey } = useContext(ApiContext);
    const { h3Demanda, corTerciaria } = useContext(StyleContext);
    const [modalAvaliar, setModalAvaliar] = useState(false);
    const [modalRelatorio, setModalRelatorio] = useState(false);
    const [modalGrafico, setModalGrafico] = useState(false);

    useEffect(() => {
        ListaCapacidadesMatriz();
    }, []);

    const processarDataSource = (data) => {
        if (!Array.isArray(data)) return [];
        return data.map(item => ({
            ...item,
            titulo: item.nivel ? `${item.nivel} - ${item.titulo}` : item.titulo,
            filhos: item.filhos ? processarDataSource(item.filhos) : [],
            isLeaf: !item.filhos || item.filhos.length === 0
        }));
    };

    const dataSourceTransformado = processarDataSource(ArvoreCapacidadesMatriz);

    const renderTree = (node) => (
        <TreeItem
            key={node.key}
            itemId={String(node.id)}
            label={
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <span>{node.titulo} {node.matrizTime ? <FcRating /> : ""}</span>
                    {node.isLeaf && (
                        <div style={{ display: "flex", gap: "5px" }}>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-add">Adicionar avaliação</Tooltip>}>
                                <button
                                    className="btn-dem"
                                    style={{ color: corTerciaria }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setModalAvaliar(true);
                                        setCapacidadeAtualKey(node.key);
                                    }}
                                >
                                    <TbPlus />
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-relatorio">Ver relatório</Tooltip>}>
                                <button
                                    className='btn-dem' style={{ color: `${corTerciaria}` }}
                                    onClick={(e) => { e.stopPropagation(); setModalRelatorio(true); setCapacidadeAtualKey(node.key);}}
                                >
                                    <HiOutlineDocumentReport />
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-grafico">Ver gráfico</Tooltip>}>
                                <button
                                    className='btn-dem' style={{ color: `${corTerciaria}` }}
                                    onClick={(e) => { e.stopPropagation(); setModalGrafico(true); setCapacidadeAtualKey(node.key);}}
                                >
                                    <HiOutlineChartSquareBar />
                                </button>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-excluir">Excluir avaliações</Tooltip>}>
                                <button
                                    className='btn-dem' style={{ color: `${corTerciaria}` }}
                                    onClick={(e) => { e.stopPropagation(); setModalExcluirMatrizTime(true); setCapacidadeAtualKey(node.key);}}
                                >
                                    <TbTrash />
                                </button>
                            </OverlayTrigger>
                        </div>
                    )}
                </div>
            }
        >
            {Array.isArray(node.filhos) && node.filhos.map(child => renderTree(child))}
        </TreeItem>
    );

    return (
        <>
            {modalAvaliar && <ModalMatrizTime setModalAvaliar={setModalAvaliar} />}
            {modalExcluirMatrizTime && <ModalExcluirMatriz />}
            {modalRelatorio && <ModalRelatorioMatriz setModalRelatorio={setModalRelatorio} />}
            {modalGrafico && <ModalGraficoMatriz setModalGrafico={setModalGrafico} />}
            {Success && <div className='success'><IoIosCheckmarkCircle className='error-icon' />{Success}</div>}
            {Error && <div className='error'><IoIosWarning className='error-icon' />{Error}</div>}
            {loading && <LoadingScreen />}
            <Header pagina={'Matriz de Avaliação'} />
            <MenuLateral />
            <div className='container-principal'>
                <div className='card card-table' style={{ marginTop: '100px' }}>
                    <h3 className='h3-demanda' style={h3Demanda}>Matriz de Avaliação</h3>
                    <SimpleTreeView
                        defaultExpandedItems={['root']}
                        slots={{
                            collapseIcon: IoIosArrowDown ,
                            expandIcon: IoIosArrowForward ,
                        }}
                    >
                        {dataSourceTransformado.map(node => renderTree(node))}
                    </SimpleTreeView>
                </div>
            </div>
            <Footer />
        </>
    );
}